// javascript
import { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import GavelIcon from '@mui/icons-material/Gavel';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PlaceIcon from '@mui/icons-material/Place';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PaidIcon from '@mui/icons-material/Paid';
import BotonWhatsapp from '../components/BotonWhatsapp';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import cambioEstadoService from '../services/cambioEstadoService';
import { subirArchivo } from '../services/archivoService';
import EventoService from '../services/eventoService';
import { listarMedicos } from '../services/medicoService';
import DatosMaestrosService from '../services/datosMaestrosService';
import ModalAgregarGastoMedico from '../components/GastosMedicosComponentes/ModalAgregarGastoMedico';
import ComboboxDatosMaestros from '../components/ComboboxDatosMaestros';
import ModificarEventoModal from '../components/ModificarEventoModal';

// Función auxiliar para obtener la fecha actual en formato YYYY-MM-DD
const obtenerFechaActual = () => {
    const hoy = new Date();
    return hoy.toISOString().split('T')[0];
};

function GestorEstadoTramiteEnJuicio({ tramite, onEstadoCambiado }) {
    const [cargando, setCargando] = useState(false);
    const [historialEstados, setHistorialEstados] = useState([]);
    const [cargandoHistorial, setCargandoHistorial] = useState(true);
    const [infoJudicial, setInfoJudicial] = useState(null);
    
    // Estados para información adicional (Turnos y Estudios)
    const [infoTurno, setInfoTurno] = useState(null);
    const [infoEstudios, setInfoEstudios] = useState(null);
    const [cargandoTurno, setCargandoTurno] = useState(false);
    const [mostrarModalGasto, setMostrarModalGasto] = useState(false);
    const [idMedicoParaGasto, setIdMedicoParaGasto] = useState(null);
    const [mostrarModificar, setMostrarModificar] = useState(false);

    // Estados para los diferentes formularios
    const [mostrarFormularioEstudios, setMostrarFormularioEstudios] = useState(false);
    const [mostrarFormularioTurno, setMostrarFormularioTurno] = useState(false);
    const [mostrarFormularioDocumentacion, setMostrarFormularioDocumentacion] = useState(false);
    
    // Estados para solicitud de estudios médicos
    const [datosSolicitudEstudios, setDatosSolicitudEstudios] = useState({
        descripcion: '',
        fechaSolicitud: obtenerFechaActual(),
        observaciones: ''
    });
    const [archivosEstudios, setArchivosEstudios] = useState([]);
    const [subiendoArchivosEstudios, setSubiendoArchivosEstudios] = useState(false);
    
    // Estados para turno médica
    const [medicos, setMedicos] = useState([]);
    const [cargandoMedicos, setCargandoMedicos] = useState(false);
    const [lugares, setLugares] = useState([]);
    const [abogados, setAbogados] = useState([]);
    const [datosTurno, setDatosTurno] = useState({
        fecha: obtenerFechaActual(),
        hora: '',
        idMedico: '',
        lugar: '',
        observaciones: ''
    });
    
    // Estados para presentación de documentación
    const [datosDocumentacion, setDatosDocumentacion] = useState({
        fechaPresentacion: '',
        descripcion: '',
        observaciones: ''
    });
    const [archivosDocumentacion, setArchivosDocumentacion] = useState([]);
    const [subiendoArchivosDocumentacion, setSubiendoArchivosDocumentacion] = useState(false);
    const [abogadoResponsable, setAbogadoResponsable] = useState('');
    
    const fileInputEstudiosRef = useRef(null);
    const fileInputDocumentacionRef = useRef(null);
    const [dragActiveEstudios, setDragActiveEstudios] = useState(false);
    const [dragActiveDocumentacion, setDragActiveDocumentacion] = useState(false);

    useEffect(() => {
        cargarHistorial();
        cargarMedicos();
        cargarLugares();
        cargarAbogados();
    }, [tramite.idTramite]);

    const cargarLugares = async () => {
        try {
            const response = await DatosMaestrosService.getLugares();
            setLugares(response.data);
        } catch (error) {
            console.error('Error al cargar lugares:', error);
        }
    };

    const cargarAbogados = async () => {
        try {
            const response = await DatosMaestrosService.getAbogados();
            setAbogados(response.data);
        } catch (error) {
            console.error('Error al cargar abogados:', error);
        }
    };

    const cargarHistorial = async () => {
        setCargandoHistorial(true);
        try {
            const historial = await cambioEstadoService.getHistorialEstados(tramite.idTramite);
            setHistorialEstados(historial);

            // Buscar información judicial del estado anterior (Segunda Apelación)
            const cambioSegundaApelacion = historial
                .filter(c => c.comentario && c.comentario.includes('Segunda Apelación (Demanda Judicial) registrada'))
                .pop();

            if (cambioSegundaApelacion && cambioSegundaApelacion.comentario) {
                parsearInfoJudicial(cambioSegundaApelacion.comentario);
            }

            // Buscar última solicitud de estudios en el historial (estado 11)
            const ultimaSolicitudEstudios = historial
                .filter(c => c.idEstado === 11 && c.comentario && c.comentario.includes('Solicitud de estudios médicos registrada'))
                .sort((a, b) => new Date(b.fechaHora) - new Date(a.fechaHora))
                .shift();

            if (ultimaSolicitudEstudios) {
                parsearInfoEstudios(ultimaSolicitudEstudios.comentario);
            }
        } catch (error) {
            console.error("Error al cargar historial:", error);
            toast.error("No se pudo cargar la información judicial.");
        } finally {
            setCargandoHistorial(false);
        }
    };

    useEffect(() => {
        const cargarUltimoTurno = async () => {
            // Verificar si hay un cambio de estado 11 con comentario de turno asignado
            const turnoAsignadoEnEsteEstado = historialEstados.some(c =>
                c.idEstado === 11 && c.comentario && c.comentario.includes('Turno médico judicial asignado')
            );

            if (!turnoAsignadoEnEsteEstado) {
                // Si no hay turno en el historial, intentar cargar el último evento de turno médico de todas formas
                // por si acaso el historial no se ha actualizado aún
                setCargandoTurno(true);
                try {
                    const response = await EventoService.getEventosPorTramite(tramite.idTramite);
                    const eventos = response.data;
                    const ultimoEventoTurno = eventos
                        .filter(e => e.tipoEvento === 'Turno Médico')
                        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))[0];
                    
                    if (ultimoEventoTurno) {
                        setInfoTurno(ultimoEventoTurno);
                    } else {
                        setInfoTurno(null);
                    }
                } catch (error) {
                    console.error("Error al cargar turno:", error);
                    setInfoTurno(null);
                } finally {
                    setCargandoTurno(false);
                }
                return;
            }

            setCargandoTurno(true);
            try {
                const response = await EventoService.getEventosPorTramite(tramite.idTramite);
                const eventos = response.data;

                // Filtrar eventos de tipo "Turno Médico" y tomar el más reciente
                const ultimoEventoTurno = eventos
                    .filter(e => e.tipoEvento === 'Turno Médico')
                    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))[0];

                setInfoTurno(ultimoEventoTurno || null);
            } catch (error) {
                console.error("Error al cargar turno:", error);
            } finally {
                setCargandoTurno(false);
            }
        };

        cargarUltimoTurno();
    }, [tramite.idTramite, historialEstados]);

    const cargarMedicos = async () => {
        setCargandoMedicos(true);
        try {
            const medicosActivos = await listarMedicos(true);
            setMedicos(medicosActivos);
        } catch (error) {
            console.error('Error al cargar médicos:', error);
            toast.error('Error al cargar la lista de médicos');
        } finally {
            setCargandoMedicos(false);
        }
    };

    const parsearInfoJudicial = (comentario) => {
        const info = {
            numeroExpediente: null,
            juzgado: null,
            secretaria: null,
            sala: null,
            fuero: null,
            fechaPresentacion: null
        };

        // Extraer número de expediente
        const expedienteMatch = comentario.match(/Número de expediente judicial \(CSS\): (.+?)(?:\n|$)/);
        if (expedienteMatch) {
            info.numeroExpediente = expedienteMatch[1].trim();
        }

        // Extraer juzgado
        const juzgadoMatch = comentario.match(/Juzgado: (.+?)(?:\n|$)/);
        if (juzgadoMatch) {
            info.juzgado = juzgadoMatch[1].trim();
        }

        // Extraer secretaría
        const secretariaMatch = comentario.match(/Secretaría: (.+?)(?:\n|$)/);
        if (secretariaMatch) {
            info.secretaria = secretariaMatch[1].trim();
        }

        // Extraer sala
        const salaMatch = comentario.match(/Sala: (.+?)(?:\n|$)/);
        if (salaMatch && !salaMatch[1].includes('No especificada')) {
            info.sala = salaMatch[1].trim();
        }

        // Extraer fuero
        const fueroMatch = comentario.match(/Fuero: (.+?)(?:\n|$)/);
        if (fueroMatch && !fueroMatch[1].includes('No especificado')) {
            info.fuero = fueroMatch[1].trim();
        }

        // Extraer fecha de presentación
        const fechaMatch = comentario.match(/Fecha de presentación: (.+?)(?:\n|$)/);
        if (fechaMatch) {
            info.fechaPresentacion = fechaMatch[1].trim();
        }

        setInfoJudicial(info);
    };

    const parsearInfoEstudios = (comentario) => {
        const info = {
            fechaSolicitud: null,
            descripcion: null,
            observaciones: null
        };

        const fechaMatch = comentario.match(/Fecha de solicitud: (.+?)(?:\n|$)/);
        if (fechaMatch) info.fechaSolicitud = fechaMatch[1].trim();

        const descripcionMatch = comentario.match(/Descripción: (.+?)(?:\n|$)/);
        if (descripcionMatch) info.descripcion = descripcionMatch[1].trim();

        const observacionesMatch = comentario.match(/Observaciones: (.+?)(?:\n|$)/);
        if (observacionesMatch) info.observaciones = observacionesMatch[1].trim();

        setInfoEstudios(info);
    };

    const formatearFecha = (fechaString) => {
        if (!fechaString) return '';
        try {
            const fecha = new Date(fechaString);
            if (isNaN(fecha.getTime())) return fechaString; // Si no es una fecha válida, retornar el string original
            const fechaLocal = new Date(fecha.valueOf() + fecha.getTimezoneOffset() * 60000);
            return fechaLocal.toLocaleDateString('es-ES', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        } catch (e) {
            return fechaString;
        }
    };

    const calcularHoraFin = (horaInicio, duracionMinutos) => {
        const [horas, minutos] = horaInicio.split(':').map(Number);
        const fechaInicio = new Date();
        fechaInicio.setHours(horas, minutos, 0, 0);
        fechaInicio.setMinutes(fechaInicio.getMinutes() + duracionMinutos);
        return fechaInicio.toTimeString().slice(0, 5);
    };

    const getFechaMinima = () => {
        const hoy = new Date();
        return hoy.toISOString().split('T')[0];
    };

    // ==================== MANEJO DE SOLICITUD DE ESTUDIOS MÉDICOS ====================
    
    const handleSeleccionarArchivosEstudios = (event) => {
        const files = Array.from(event.target.files || []);
        if (files.length === 0) return;

        const nuevosArchivos = files.map(file => ({
            id: `local_${Date.now()}_${Math.random()}`,
            file,
            nombre: file.name,
            tamaño: (file.size / (1024 * 1024)).toFixed(2) + " MB",
            estado: "pendiente",
            esDelBackend: false
        }));

        setArchivosEstudios(prev => [...prev, ...nuevosArchivos]);
        if (event.target) event.target.value = "";
    };

    const handleDragEstudios = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") setDragActiveEstudios(true);
        else if (e.type === "dragleave") setDragActiveEstudios(false);
    };

    const handleDropEstudios = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActiveEstudios(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleSeleccionarArchivosEstudios({ target: { files: e.dataTransfer.files } });
        }
    };

    const handleEliminarArchivoEstudios = (id) => {
        setArchivosEstudios(prev => prev.filter(a => a.id !== id));
    };

    const handleRegistrarSolicitudEstudios = async () => {
        if (!datosSolicitudEstudios.descripcion.trim()) {
            toast.error("La descripción de la solicitud es obligatoria.");
            return;
        }

        setCargando(true);
        try {
            // Crear comentario y registrar como cambio de estado con el mismo estado (para mantener historial)
            const comentario = `Solicitud de estudios médicos registrada\nFecha de solicitud: ${formatearFecha(obtenerFechaActual())}\nDescripción: ${datosSolicitudEstudios.descripcion}`;

            // Mantener en el mismo estado pero registrar la acción en el historial
            const cambioEstadoData = {
                idEstado: 11, // Mantener en estado 11 (Trámite en Juicio)
                comentario: comentario
            };
            
            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);
            
            toast.success("Solicitud de estudios médicos registrada correctamente.");
            
            // Limpiar formulario
            setMostrarFormularioEstudios(false);
            setDatosSolicitudEstudios({ descripcion: '', fechaSolicitud: obtenerFechaActual(), observaciones: '' });

            if (onEstadoCambiado) {
                await onEstadoCambiado();
            }

        } catch (error) {
            console.error("Error al registrar solicitud de estudios:", error);
            toast.error("Error al registrar la solicitud de estudios: " + (error.response?.data || error.message));
        } finally {
            setCargando(false);
        }
    };

    // ==================== MANEJO DE TURNO MÉDICA ====================
    
    // Función para crear lugar automáticamente si no existe
    const crearLugarSiNoExiste = async (nombreLugar, tipoLugar = 'Consultorio') => {
        if (!nombreLugar || nombreLugar.trim() === '') return;

        const nombreTrim = nombreLugar.trim();
        
        // Verificar si ya existe
        const lugarExistente = lugares.find(l => 
            l.nombre && l.nombre.toLowerCase() === nombreTrim.toLowerCase()
        );
        
        if (lugarExistente) {
            return lugarExistente; // Ya existe
        }

        try {
            const nuevoLugar = {
                nombre: nombreTrim,
                tipo: tipoLugar,
                direccion: '',
                telefono: '',
                descripcion: `Creado automáticamente desde trámite`
            };
            const response = await DatosMaestrosService.createLugar(nuevoLugar);
            console.log('✅ Lugar creado automáticamente:', response.data);
            
            // Recargar lugares para incluir el nuevo
            const lugaresActualizados = await DatosMaestrosService.getLugares();
            setLugares(lugaresActualizados.data);
            
            return response.data;
        } catch (error) {
            console.error('Error al crear lugar automáticamente:', error);
            return null;
        }
    };

    const handleAsignarTurnoMedica = async () => {
        if (!datosTurno.fecha || !datosTurno.hora || !datosTurno.idMedico) {
            toast.error('Debe seleccionar fecha, hora y médico');
            return;
        }

        setCargando(true);
        try {
            // Crear lugar automáticamente si no existe
            if (datosTurno.lugar && datosTurno.lugar.trim() !== '') {
                await crearLugarSiNoExiste(datosTurno.lugar, 'Consultorio');
            }

            const medicoSeleccionado = medicos.find(m => m.idMedico === parseInt(datosTurno.idMedico));
            const nombreMedico = medicoSeleccionado ? `${medicoSeleccionado.nombre} ${medicoSeleccionado.apellido}` : 'No especificida';

            // Crear evento en el calendario con manejo robusto de errores
            const eventoData = {
                titulo: `Turno Médico Judicial - ${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`,
                descripcion: `Médico: ${nombreMedico} - Lugar: ${datosTurno.lugar || 'No especificado'} - Observación: ${datosTurno.observaciones || 'No especificadas'}`,
                fecha: datosTurno.fecha,
                horaInicio: datosTurno.hora,
                horaFin: calcularHoraFin(datosTurno.hora, 60),
                todoElDia: false,
                tipoEvento: 'Turno Médico',
                idTramite: tramite.idTramite,
                visibilidad: 'POR_AREA',
                canalesNotificacion: {
                    whatsapp: false,
                    email: false,
                    inapp: true
                }
            };
            
            try {
                await EventoService.crearEvento(eventoData);
                console.log('✅ Evento judicial creado exitosamente');
            } catch (error) {
                // Si hay error al crear el evento, propagarlo
                console.error('❌ Error al crear evento judicial:', error);
                throw error;
            }

            // Disparar evento para actualizar calendario
            try {
                window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { 
                    detail: { timestamp: Date.now(), source: 'tramite' } 
                }));
            } catch (error) {
                // Si falla el evento personalizado, no es crítico
                console.warn('⚠️ No se pudo disparar el evento personalizado:', error);
            }

            const comentario = `Turno médico judicial asignado\nFecha: ${formatearFecha(datosTurno.fecha)} ${datosTurno.hora}\nMédico: ${nombreMedico}\nLugar: ${datosTurno.lugar || 'No especificado'}\nObservación: ${datosTurno.observaciones || 'No especificadas'}`;

            // Mantener en el mismo estado pero registrar la acción en el historial
            const cambioEstadoData = {
                idEstado: 11, // Mantener en estado 11 (Trámite en Juicio)
                comentario: comentario
            };
            
            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);
            
            // Recargar el historial para que el useEffect detecte el cambio
            await cargarHistorial();
            
            // Recargar el turno inmediatamente después de crearlo
            try {
                const response = await EventoService.getEventosPorTramite(tramite.idTramite);
                const eventos = response.data;
                const ultimoEventoTurno = eventos
                    .filter(e => e.tipoEvento === 'Turno Médico')
                    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))[0];
                if (ultimoEventoTurno) {
                    setInfoTurno(ultimoEventoTurno);
                }
            } catch (error) {
                console.error("Error al recargar turno:", error);
            }
            
            toast.success('Turno médico judicial asignado y evento creado correctamente');
            setMostrarFormularioTurno(false);
            setDatosTurno({ fecha: obtenerFechaActual(), hora: '', idMedico: '', lugar: '', observaciones: '' });

            if (onEstadoCambiado) {
                await onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al asignar turno:', error);
            toast.error('Error al asignar el turno: ' + (error.response?.data || error.message));
        } finally {
            setCargando(false);
        }
    };

    // ==================== MANEJO DE PRESENTACIÓN DE DOCUMENTACIÓN ====================
    
    const handleSeleccionarArchivosDocumentacion = (event) => {
        const files = Array.from(event.target.files || []);
        if (files.length === 0) return;

        const nuevosArchivos = files.map(file => ({
            id: `local_${Date.now()}_${Math.random()}`,
            file,
            nombre: file.name,
            tamaño: (file.size / (1024 * 1024)).toFixed(2) + " MB",
            estado: "pendiente",
            esDelBackend: false
        }));

        setArchivosDocumentacion(prev => [...prev, ...nuevosArchivos]);
        if (event.target) event.target.value = "";
    };

    const handleDragDocumentacion = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") setDragActiveDocumentacion(true);
        else if (e.type === "dragleave") setDragActiveDocumentacion(false);
    };

    const handleDropDocumentacion = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActiveDocumentacion(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleSeleccionarArchivosDocumentacion({ target: { files: e.dataTransfer.files } });
        }
    };

    const handleEliminarArchivoDocumentacion = (id) => {
        setArchivosDocumentacion(prev => prev.filter(a => a.id !== id));
    };

    const handleRegistrarPresentacionDocumentacion = async () => {
        if (!datosDocumentacion.fechaPresentacion) {
            toast.error("La fecha de presentación es obligatoria.");
            return;
        }
        if (!datosDocumentacion.descripcion.trim()) {
            toast.error("La descripción de la documentación es obligatoria.");
            return;
        }
        const archivosPendientes = archivosDocumentacion.filter(a => a.estado === 'pendiente');
        if (archivosPendientes.length === 0) {
            toast.error("Debe adjuntar al menos un archivo de documentación.");
            return;
        }

        setCargando(true);
        setSubiendoArchivosDocumentacion(true);
        try {
            // Subir archivos
            const archivosSubidos = [];
            for (const archivo of archivosPendientes) {
                try {
                    const archivoSubido = await subirArchivo(tramite.idTramite, archivo.file);
                    archivosSubidos.push(archivoSubido);
                    setArchivosDocumentacion(prev => prev.map(item =>
                        item.id === archivo.id ? { ...item, estado: "subido", idArchivo: archivoSubido.idArchivo, esDelBackend: true } : item
                    ));
                } catch (error) {
                    toast.error(`Error subiendo ${archivo.nombre}`);
                    throw error;
                }
            }
            setSubiendoArchivosDocumentacion(false);

            // Crear comentario
            const comentario = `Presentación de documentación registrada\nFecha de presentación: ${formatearFecha(datosDocumentacion.fechaPresentacion)}\nDescripción: ${datosDocumentacion.descripcion}\nObservaciones: ${datosDocumentacion.observaciones || 'No especificadas'}\nAbogado responsable: ${abogadoResponsable || 'No especificado'}\nArchivos adjuntos: ${archivosSubidos.map(a => a.nombre).join(', ')}`;

            // Cambiar a estado "Espera Fecha de Pericia" (estado 16)
            const cambioEstadoData = {
                idEstado: 16, // Espera Fecha de Pericia
                comentario: comentario
            };
            
            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);
            
            toast.success("Presentación de documentación registrada. El trámite ahora está en espera de fecha de pericia.");
            
            // Limpiar formulario
            setMostrarFormularioDocumentacion(false);
            setArchivosDocumentacion([]);
            setDatosDocumentacion({ fechaPresentacion: '', descripcion: '', observaciones: '' });
            setAbogadoResponsable('');

            if (onEstadoCambiado) {
                await onEstadoCambiado();
            }

        } catch (error) {
            console.error("Error al registrar presentación de documentación:", error);
            toast.error("Error al registrar la presentación de documentación: " + (error.response?.data || error.message));
        } finally {
            setCargando(false);
            setSubiendoArchivosDocumentacion(false);
        }
    };

    // Funciones auxiliares para el turno médico (replicadas de GestorEstadoTramite)
    const handleNoAsistio = async () => {
        setCargando(true);
        try {
            const cambioEstadoData = {
                idEstado: 11, // Mantener en estado 11
                comentario: `⚠️ INASISTENCIA - El cliente no asistió al turno médico judicial.`
            };

            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);
            toast.warning('Inasistencia registrada');

            // Opcional: Abrir formulario de reprogramación automáticamente
            setMostrarFormularioTurno(true);

            if (onEstadoCambiado) onEstadoCambiado();
        } catch (error) {
            console.error('Error al registrar inasistencia:', error);
            toast.error('Error al registrar la inasistencia');
        } finally {
            setCargando(false);
        }
    };

    // Renderizado de tarjetas de información
    const renderInfoTurno = () => {
        if (cargandoTurno) {
            return <div className="alert alert-info">Cargando información del turno...</div>;
        }
        if (!infoTurno) return null;

        const descripcion = infoTurno.descripcion || '';
        const medicoMatch = descripcion.match(/Médico: (.*?)(?:\s-|$)/);
        const lugarMatch = descripcion.match(/Lugar: (.*?)(?:\s-|$)/);
        const observacionesMatch = descripcion.match(/Observación: (.*?)(?:$)/);

        const fechaTurno = formatearFecha(infoTurno.fecha);
        const horaTurno = infoTurno.horaInicio || 'No especificada';
        const nombreMedico = medicoMatch ? medicoMatch[1] : 'No especificado';
        const lugarTurno = lugarMatch ? lugarMatch[1] : 'No especificado';
        const observacionesTurno = observacionesMatch ? observacionesMatch[1] : 'No especificadas';

        return (
            <div className="card bg-white border border-success rounded-3 p-4 mb-4 shadow-sm">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-semibold text-success mb-0">
                        Turno Médico Asignado
                    </h5>
                    <span className="badge bg-success rounded-pill px-3 py-2">
                        <EventAvailableIcon fontSize="small" className="me-1" />
                        Confirmado
                    </span>
                </div>

                <div className="row g-3">
                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <CalendarMonthIcon fontSize="small" className="text-success me-2" />
                            <div>
                                <small className="text-muted d-block">Fecha</small>
                                <strong className="text-dark">{fechaTurno}</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <AccessTimeIcon fontSize="small" className="text-success me-2" />
                            <div>
                                <small className="text-muted d-block">Hora</small>
                                <strong className="text-dark">{horaTurno.slice(0, 5)}</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <PersonIcon fontSize="small" className="text-success me-2" />
                            <div>
                                <small className="text-muted d-block">Médico</small>
                                <strong className="text-dark">{nombreMedico}</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <PlaceIcon fontSize="small" className="text-success me-2" />
                            <div>
                                <small className="text-muted d-block">Lugar</small>
                                <strong className="text-dark">{lugarTurno}</strong>
                            </div>
                        </div>
                    </div>
                </div>

                {observacionesTurno && (
                    <div className="mt-3 p-3 bg-light rounded-3 border">
                        <small className="text-muted d-block mb-1">Observación:</small>
                        <small className="text-dark" style={{ whiteSpace: 'pre-line' }}>
                            {observacionesTurno}
                        </small>
                    </div>
                )}

                <div className="mt-3 d-flex gap-2 flex-wrap">
                    <BotonWhatsapp
                        idEvento={infoTurno?.idEvento}
                        numeroTelefono={tramite.cliente?.telefonoPropio || tramite.cliente?.telefono}
                        nombreCliente={`${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`.trim()}
                        contactosAdicionales={tramite.cliente?.contactos}
                        fechaTurno={infoTurno?.fecha}
                        horaTurno={infoTurno?.horaInicio || infoTurno?.hora}
                        lugar={lugarTurno}
                        tipoEvento="Turno Médico Judicial"
                        tramiteId={tramite?.idTramite}
                        className="btn-sm"
                    />
                    <button
                        className="btn btn-sm btn-outline-success rounded-pill"
                        onClick={() => {
                            const medicoDelTurno = medicos.find(m => `${m.nombre} ${m.apellido}` === nombreMedico);
                            setIdMedicoParaGasto(medicoDelTurno ? medicoDelTurno.idMedico : null);
                            setMostrarModalGasto(true);
                        }}
                    >
                        <PaidIcon fontSize="small" className="me-1" />
                        Agregar Gasto Médico
                    </button>
                    <button
                        className="btn btn-sm btn-outline-warning rounded-pill"
                        onClick={() => setMostrarFormularioTurno(true)}
                    >
                        <EditCalendarIcon fontSize="small" className="me-1" />
                        Reprogramar
                    </button>
                    <button
                        className="btn btn-sm btn-outline-info rounded-pill"
                        onClick={() => setMostrarModificar(true)}
                        disabled={cargando}
                    >
                        <EditCalendarIcon fontSize="small" className="me-1" />
                        Modificar Turno
                    </button>
                    <button
                        className="btn btn-sm btn-outline-danger rounded-pill"
                        onClick={handleNoAsistio}
                    >
                        <EventBusyIcon fontSize="small" className="me-1" />
                        No Asistió
                    </button>
                </div>
            </div>
        );
    };

    const renderInfoEstudios = () => {
        if (!infoEstudios) return null;

        return (
            <div className="card bg-white border border-info rounded-3 p-4 mb-4 shadow-sm">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-semibold text-info mb-0">
                        Solicitud de Estudios Médicos
                    </h5>
                    <span className="badge bg-info rounded-pill px-3 py-2">
                        <RuleFolderIcon fontSize="small" className="me-1" />
                        Registrada
                    </span>
                </div>

                <div className="row g-3">
                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <CalendarMonthIcon fontSize="small" className="text-info me-2" />
                            <div>
                                <small className="text-muted d-block">Fecha de Solicitud</small>
                                <strong className="text-dark">{infoEstudios.fechaSolicitud}</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="p-3 bg-light rounded-3 border">
                            <small className="text-muted d-block mb-1">Descripción:</small>
                            <p className="text-dark mb-0" style={{ whiteSpace: 'pre-line' }}>{infoEstudios.descripcion}</p>
                        </div>
                    </div>
                    {infoEstudios.observaciones && (
                        <div className="col-12">
                            <small className="text-muted d-block mb-1">Observaciones:</small>
                            <p className="text-dark mb-0">{infoEstudios.observaciones}</p>
                        </div>
                    )}
                </div>

                {/* Gestor de Archivos en la tarjeta */}
                <div className="mt-4 border-top pt-3">
                    <h6 className="fw-semibold text-primary mb-3">Adjuntar Estudios/Resultados</h6>

                    {archivosEstudios.length > 0 && (
                        <div className="list-group mb-3">
                            {archivosEstudios.map(archivo => (
                                <div key={archivo.id} className="list-group-item d-flex justify-content-between align-items-center">
                                    <div>
                                        <AttachFileIcon fontSize="small" className="me-2 text-muted" />
                                        <span className="fw-semibold">{archivo.nombre}</span>
                                        <small className="text-muted ms-2">({archivo.tamaño})</small>
                                        <span className={`badge ms-2 ${archivo.estado === 'subido' ? 'bg-success' : 'bg-warning text-dark'}`}>
                                            {archivo.estado}
                                        </span>
                                    </div>
                                    <button
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleEliminarArchivoEstudios(archivo.id)}
                                        title="Eliminar"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}

                    <div
                        className={`border rounded-3 p-4 text-center cursor-pointer ${dragActiveEstudios ? "border-primary bg-primary bg-opacity-10" : "border-dashed"}`}
                        onDragEnter={handleDragEstudios}
                        onDragLeave={handleDragEstudios}
                        onDragOver={handleDragEstudios}
                        onDrop={handleDropEstudios}
                        onClick={() => fileInputEstudiosRef.current?.click()}
                    >
                        <input
                            type="file"
                            ref={fileInputEstudiosRef}
                            onChange={handleSeleccionarArchivosEstudios}
                            className="d-none"
                            multiple
                        />
                        <CloudUploadIcon className="text-muted mb-2" />
                        <p className="mb-0">Arrastra los archivos aquí o haz clic para seleccionar</p>
                        <small className="text-muted">Múltiples archivos permitidos</small>
                    </div>

                    {archivosEstudios.some(a => a.estado === 'pendiente') && (
                        <div className="d-flex justify-content-center mt-3">
                            <button
                                className="btn btn-primary rounded-pill px-4"
                                onClick={async () => {
                                    setSubiendoArchivosEstudios(true);
                                    try {
                                        const archivosPendientes = archivosEstudios.filter(a => a.estado === 'pendiente');
                                        for (const archivo of archivosPendientes) {
                                            try {
                                                const archivoSubido = await subirArchivo(tramite.idTramite, archivo.file);
                                                setArchivosEstudios(prev => prev.map(item =>
                                                    item.id === archivo.id ? { ...item, estado: "subido", idArchivo: archivoSubido.idArchivo, esDelBackend: true } : item
                                                ));
                                            } catch (error) {
                                                toast.error(`Error subiendo ${archivo.nombre}`);
                                            }
                                        }
                                        toast.success("Archivos subidos correctamente");
                                    } catch (error) {
                                        console.error("Error al subir archivos:", error);
                                        toast.error("Error al subir archivos");
                                    } finally {
                                        setSubiendoArchivosEstudios(false);
                                    }
                                }}
                                disabled={subiendoArchivosEstudios}
                            >
                                <CloudUploadIcon fontSize="small" className="me-2" />
                                {subiendoArchivosEstudios ? 'Subiendo...' : 'Subir Archivos'}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    if (cargandoHistorial) {
        return (
            <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
                <div className="alert alert-info">Cargando información judicial...</div>
            </div>
        );
    }

    const handleGuardarModificacionEvento = async (idEvento, eventoActualizado) => {
        try {
            await EventoService.modificarEvento(idEvento, eventoActualizado);
            setMostrarModificar(false);

            const response = await EventoService.getEventosPorTramite(tramite.idTramite);
            const eventos = response.data;
            const ultimoEventoTurno = eventos
                .filter(e => e.tipoEvento === 'Turno Médico' || e.tipoEvento === 'Turno Medico')
                .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))[0];
            if (ultimoEventoTurno) {
                setInfoTurno(ultimoEventoTurno);
            }
            toast.success('Turno actualizado correctamente');
        } catch (error) {
            console.error('Error al recargar turno:', error);
            toast.error('No se pudo actualizar el turno');
        }
    };

    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold text-primary mb-0">
                    <GavelIcon className="me-2" />
                    Trámite en Juicio (Instancia Judicial)
                </h4>
            </div>

            {/* Información Judicial */}
            {infoJudicial && (
                <div className="mt-3 p-3 bg-light rounded-3 border mb-4">
                    <h6 className="fw-semibold text-secondary mb-3">Información Judicial</h6>
                    <div className="row g-3">
                        {infoJudicial.numeroExpediente && (
                            <div className="col-md-6 d-flex align-items-center">
                                <DescriptionIcon className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">N° Expediente Judicial (CSS)</small>
                                    <strong className="text-dark">{infoJudicial.numeroExpediente}</strong>
                                </div>
                            </div>
                        )}
                        {infoJudicial.juzgado && (
                            <div className="col-md-6 d-flex align-items-center">
                                <BusinessIcon className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Juzgado</small>
                                    <strong className="text-dark">{infoJudicial.juzgado}</strong>
                                </div>
                            </div>
                        )}
                        {infoJudicial.secretaria && (
                            <div className="col-md-6 d-flex align-items-center">
                                <AssignmentIcon className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Secretaría</small>
                                    <strong className="text-dark">{infoJudicial.secretaria}</strong>
                                </div>
                            </div>
                        )}
                        {infoJudicial.sala && (
                            <div className="col-md-6 d-flex align-items-center">
                                <BusinessIcon className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Sala</small>
                                    <strong className="text-dark">{infoJudicial.sala}</strong>
                                </div>
                            </div>
                        )}
                        {infoJudicial.fuero && (
                            <div className="col-md-6 d-flex align-items-center">
                                <GavelIcon className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Fuero</small>
                                    <strong className="text-dark">{infoJudicial.fuero}</strong>
                                </div>
                            </div>
                        )}
                        {infoJudicial.fechaPresentacion && (
                            <div className="col-md-6 d-flex align-items-center">
                                <CalendarMonthIcon className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Fecha de Presentación</small>
                                    <strong className="text-dark">{infoJudicial.fechaPresentacion}</strong>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Botones de Acción */}
            <div className="d-flex justify-content-center flex-wrap gap-3 mt-4 pt-3 border-top">
                <button
                    className="btn btn-info d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={() => setMostrarFormularioEstudios(true)}
                    disabled={cargando}
                >
                    <MedicalServicesIcon fontSize="small" />
                    Registrar Solicitud de Estudios Médicos
                </button>
                <button
                    className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={() => setMostrarFormularioTurno(true)}
                    disabled={cargando}
                >
                    <CalendarMonthIcon fontSize="small" />
                    Asignar Turno Médica
                </button>
                <button
                    className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={() => setMostrarFormularioDocumentacion(true)}
                    disabled={cargando}
                >
                    <NoteAddIcon fontSize="small" />
                    Registrar Presentación de Documentación
                </button>
            </div>

            {/* Formulario: Solicitud de Estudios Médicos */}
            {mostrarFormularioEstudios && (
                <div className="mt-4">
                    <div className="card shadow-sm border-0 rounded-4 p-4">
                        <h5 className="fw-semibold text-info mb-3">Registrar Solicitud de Estudios Médicos</h5>
                        
                        <div className="row g-3">
                            <div className="col-12">
                                <label className="form-label fw-semibold">
                                    Detalle de estudios/documentos solicitados <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={datosSolicitudEstudios.descripcion}
                                    onChange={e => setDatosSolicitudEstudios({ ...datosSolicitudEstudios, descripcion: e.target.value })}
                                    placeholder="Ej: Se solicita radiografía de tórax y análisis de sangre completo."
                                    required
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <button
                                className="btn btn-info d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={handleRegistrarSolicitudEstudios}
                                disabled={cargando}
                            >
                                <CheckCircleIcon fontSize="small" />
                                {cargando ? 'Registrando...' : 'Confirmar Solicitud'}
                            </button>
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => {
                                    setMostrarFormularioEstudios(false);
                                    setDatosSolicitudEstudios({ descripcion: '', fechaSolicitud: obtenerFechaActual(), observaciones: '' });
                                }}
                                disabled={cargando}
                            >
                                <CancelIcon fontSize="small" />
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Formulario: Asignar Turno Médico */}
            {mostrarFormularioTurno && (
                <div className="mt-4">
                    <div className="card shadow-sm border-0 rounded-4 p-4">
                        <h5 className="fw-semibold text-success mb-3">Asignar Turno Médico</h5>
                        
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    Fecha <span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light"><CalendarMonthIcon fontSize="small" /></span>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={datosTurno.fecha}
                                        onChange={e => setDatosTurno({ ...datosTurno, fecha: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    Hora <span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light"><AccessTimeIcon fontSize="small" /></span>
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={datosTurno.hora}
                                        onChange={e => setDatosTurno({ ...datosTurno, hora: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    Médico <span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light"><PersonIcon fontSize="small" /></span>
                                    <select
                                        className="form-select"
                                        value={datosTurno.idMedico}
                                        onChange={e => setDatosTurno({ ...datosTurno, idMedico: e.target.value })}
                                        disabled={cargandoMedicos}
                                        required
                                    >
                                        <option value="">Seleccionar médico...</option>
                                        {medicos.map(medico => (
                                            <option key={medico.idMedico} value={medico.idMedico}>
                                                {medico.nombre} {medico.apellido} {medico.matricula ? `(Mat: ${medico.matricula})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {cargandoMedicos && <small className="text-muted">Cargando médicos...</small>}
                            </div>
                            <div className="col-md-6">
                                <ComboboxDatosMaestros
                                    opciones={lugares.filter(l => l.tipo === 'Consultorio' || !l.tipo)}
                                    valor={datosTurno.lugar}
                                    onChange={(valor) => setDatosTurno({ ...datosTurno, lugar: valor })}
                                    tipo="lugar"
                                    tipoLugar="Consultorio"
                                    placeholder="Seleccione o escriba un lugar..."
                                    label="Lugar"
                                    icon={PlaceIcon}
                                />
                            </div>
                            <div className="col-12">
                                <label className="form-label fw-semibold">
                                    Observaciones
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    value={datosTurno.observaciones}
                                    onChange={e => setDatosTurno({ ...datosTurno, observaciones: e.target.value })}
                                    placeholder="Observaciones adicionales..."
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <button
                                className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={handleAsignarTurnoMedica}
                                disabled={cargando}
                            >
                                <CheckCircleIcon fontSize="small" />
                                {cargando ? 'Asignando...' : 'Asignar Turno'}
                            </button>
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => {
                                    setMostrarFormularioTurno(false);
                                    setDatosTurno({ fecha: obtenerFechaActual(), hora: '', idMedico: '', lugar: '', observaciones: '' });
                                }}
                                disabled={cargando}
                            >
                                <CancelIcon fontSize="small" />
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Formulario: Presentación de Documentación */}
            {mostrarFormularioDocumentacion && (
                <div className="mt-4">
                    <div className="card shadow-sm border-0 rounded-4 p-4">
                        <h5 className="fw-semibold text-primary mb-3">Registrar Presentación de Documentación</h5>
                        
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    Fecha de Presentación <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={datosDocumentacion.fechaPresentacion}
                                    onChange={e => setDatosDocumentacion({ ...datosDocumentacion, fechaPresentacion: e.target.value })}
                                    min={getFechaMinima()}
                                    required
                                />
                            </div>
                            <div className="col-md-6">
                                <ComboboxDatosMaestros
                                    opciones={abogados}
                                    valor={abogadoResponsable}
                                    onChange={(valor) => setAbogadoResponsable(valor)}
                                    tipo="abogado"
                                    placeholder="Seleccione o escriba un abogado..."
                                    label="Abogado Responsable"
                                    icon={AssignmentIcon}
                                />
                            </div>
                            <div className="col-12">
                                <label className="form-label fw-semibold">
                                    Descripción <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={datosDocumentacion.descripcion}
                                    onChange={e => setDatosDocumentacion({ ...datosDocumentacion, descripcion: e.target.value })}
                                    placeholder="Describa la documentación presentada al tribunal..."
                                    required
                                />
                            </div>
                            <div className="col-12">
                                <label className="form-label fw-semibold">Observaciones</label>
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    value={datosDocumentacion.observaciones}
                                    onChange={e => setDatosDocumentacion({ ...datosDocumentacion, observaciones: e.target.value })}
                                    placeholder="Observaciones adicionales..."
                                />
                            </div>
                        </div>

                        {/* Gestor de Archivos */}
                        <div className="mt-4">
                            <h6 className="fw-semibold text-primary">Documentación Adjunta <span className="text-danger">*</span></h6>
                            {archivosDocumentacion.length > 0 && (
                                <div className="list-group mb-3">
                                    {archivosDocumentacion.map(archivo => (
                                        <div key={archivo.id} className="list-group-item d-flex justify-content-between align-items-center">
                                            <div>
                                                <AttachFileIcon fontSize="small" className="me-2 text-muted" />
                                                <span className="fw-semibold">{archivo.nombre}</span>
                                                <small className="text-muted ms-2">({archivo.tamaño})</small>
                                                <span className={`badge ms-2 ${archivo.estado === 'subido' ? 'bg-success' : 'bg-warning text-dark'}`}>
                                                    {archivo.estado}
                                                </span>
                                            </div>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleEliminarArchivoDocumentacion(archivo.id)}
                                                title="Eliminar"
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <div
                                className={`border rounded-3 p-4 text-center cursor-pointer ${dragActiveDocumentacion ? "border-primary bg-primary bg-opacity-10" : "border-dashed"}`}
                                onDragEnter={handleDragDocumentacion}
                                onDragLeave={handleDragDocumentacion}
                                onDragOver={handleDragDocumentacion}
                                onDrop={handleDropDocumentacion}
                                onClick={() => fileInputDocumentacionRef.current?.click()}
                            >
                                <input
                                    type="file"
                                    ref={fileInputDocumentacionRef}
                                    onChange={handleSeleccionarArchivosDocumentacion}
                                    className="d-none"
                                    multiple
                                />
                                <CloudUploadIcon className="text-muted mb-2" />
                                <p className="mb-0">Arrastra los archivos aquí o haz clic para seleccionar</p>
                                <small className="text-muted">Múltiples archivos permitidos</small>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <button
                                className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={handleRegistrarPresentacionDocumentacion}
                                disabled={cargando || subiendoArchivosDocumentacion}
                            >
                                <CheckCircleIcon fontSize="small" />
                                {cargando || subiendoArchivosDocumentacion ? 'Registrando...' : 'Registrar Presentación'}
                            </button>
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => {
                                    setMostrarFormularioDocumentacion(false);
                                    setArchivosDocumentacion([]);
                                    setDatosDocumentacion({ fechaPresentacion: '', descripcion: '', observaciones: '' });
                                    setAbogadoResponsable('');
                                }}
                                disabled={cargando || subiendoArchivosDocumentacion}
                            >
                                <CancelIcon fontSize="small" />
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Información Adicional */}
            <div className="mt-4">
                {renderInfoTurno()}
                {renderInfoEstudios()}
            </div>

            {/* Modal Agregar Gasto Médico */}
            <ModalAgregarGastoMedico
                open={mostrarModalGasto}
                onClose={() => setMostrarModalGasto(false)}
                onGastoAgregado={() => {
                    toast.success('Gasto médico agregado correctamente');
                    setMostrarModalGasto(false);
                }}
                preSelectedMedico={idMedicoParaGasto}
                preSelectedTramite={tramite.idTramite}
            />

            <ModificarEventoModal
                isOpen={mostrarModificar}
                onClose={() => setMostrarModificar(false)}
                evento={infoTurno}
                onSave={handleGuardarModificacionEvento}
            />
        </div>
    );
}


export default GestorEstadoTramiteEnJuicio;

